import FeatureCompanies from "./FeatureCompanies";
import heroImage from "../assets/image.png";
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const Hero = () => {
    const navigate = useNavigate(); // Initialize useNavigate

    const handleBookCall = () => {
        // You would replace this with your actual booking link or modal
        window.open('https://calendly.com/bonaogeto/book-a-call', '_blank');
    };
    
    const handleGetStarted = () => {
        navigate('/programs'); // Navigate to the programs page
    };

    return (
        <div className="hero">
            <section className="bg-white dark:bg-gray-900">
                <div className="grid max-w-screen-xl px-4 mx-auto h-screen lg:h-[calc(90vh)] lg:gap-8 xl:gap-0 lg:grid-cols-12 lg:items-center">
                    <div className="mr-auto place-self-center lg:col-span-7">
                        <h1 className="max-w-2xl mb-6 text-4xl font-extrabold leading-none tracking-tight md:text-5xl xl:text-6xl dark:text-white">
                            <span className="block">Where Swiss Quality</span>
                            <span className="block text-purple-600 dark:text-purple-500">Meets Tech Education</span>
                        </h1>
                        <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-base lg:text-lg dark:text-gray-400">
                        Embark on a transformative journey with Swiss Tech Academy. Whether you're launching a new career, upskilling, or diving into the tech world, our world-class training in Web Development, Software Engineering, and Data Science is tailored for your success. Build a portfolio that stands out and become a leader in innovation.
                            
                        </p>
                        <div className="space-y-4 sm:flex sm:space-y-0 sm:space-x-4">
                            <button 
                                onClick={handleBookCall}
                                className="inline-flex items-center justify-center px-6 py-3 text-base font-medium text-center text-white bg-purple-600 rounded-lg hover:bg-purple-700 focus:ring-4 focus:ring-purple-300 dark:focus:ring-purple-900 shadow-lg transform transition-transform duration-300 hover:scale-105"
                            >
                                Book Free Consultation
                                <svg className="w-5 h-5 ml-2 -mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                            </button>
                            <button
                                onClick={handleGetStarted}
                                className="inline-flex items-center justify-center px-6 py-3 text-base font-medium text-center text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:bg-gray-700 dark:border-gray-600 dark:hover:bg-gray-600 dark:focus:ring-gray-800 transform transition-transform duration-300 hover:scale-105"
                            >
                                Explore Courses
                            </button>
                        </div>
                    </div>
                    <div className="relative mt-10 lg:mt-0 lg:col-span-5 h-64 sm:h-80 md:h-96 lg:h-full">
                        <img
                            src={heroImage}
                            alt="Hero section illustration"
                            className="w-full h-full object-cover rounded-lg shadow-lg"
                        />
                    </div>
                </div>
            </section>
            <FeatureCompanies />
        </div>
    );
};

export default Hero;